import { connect } from 'react-redux';
import UpcomingEventPage from './UpcomingEventPage';

const mapStateToProps = ({ settings }) => ({
  ...settings,
  xPropMode: window.xprops.data.mode,
  onTrigger: window.xprops.onTrigger,
});

const UpcomingEventPageConnected = connect(
  mapStateToProps,
  null,
)(UpcomingEventPage);

export default UpcomingEventPageConnected;
